import { render, staticRenderFns } from "./Confetti.vue?vue&type=template&id=a2397bd0&"
import script from "./Confetti.vue?vue&type=script&lang=js&"
export * from "./Confetti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vagrant/webdev/craft/craft-imageoptimize/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a2397bd0', component.options)
    } else {
      api.reload('a2397bd0', component.options)
    }
    module.hot.accept("./Confetti.vue?vue&type=template&id=a2397bd0&", function () {
      api.rerender('a2397bd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assetbundles/imageoptimize/src/vue/Confetti.vue"
export default component.exports